var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'font-sans fixed inset-0 z-backdrop w-full h-vh100 bg-modal-overlay-light dark:bg-modal-overlay-grey',
    'flex flex-col justify-end md:justify-center items-center overflow-hidden md:overflow-auto',
    'dark:backdrop-filter dark:backdrop-blur-10' ],on:{"mousedown":function($event){if($event.target !== $event.currentTarget){ return null; }$event.stopPropagation();return _vm.cancel($event)},"touchstart":function($event){if($event.target !== $event.currentTarget){ return null; }$event.stopPropagation();return _vm.cancel($event)}}},[_c('div',{class:[
      'p-4',
      'w-full',
      'mx-auto',
      'z-modal',
      'box-border',
      'rounded-3xl',
      'bg-white-100',
      'dark:bg-nightfall-900',
      _vm.modalSizeClass ].concat( (_vm.isPhone
        ? ['animate-slide-up', 'max-h-screen-with-space-8', 'overflow-auto', 'rounded-b-none']
        : ['animate-fade-in', 'relative']) )},[_vm._t("modal")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }